import React, { Component, Fragment } from "react";
import Relatorio4 from "../../Components/ProducaoSTI/Realizado/Relatorio4/Index";
import NomeUnidade from "../../Components/UI/NomeUnidade";
import MenuRelatorioSTI from "./menuRelatorioSTI";

export default class PageRelatorio2 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Relatório"
        }
    }

    render() {
        return(
            <Fragment>

                <NomeUnidade unidade={"Relatórios"} />

                <div className="content">
                    <MenuRelatorioSTI />
                    <div className="row">
                        <div className="col-md-12">
                            <Relatorio4 />
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}